import React  from "react";
import Modal from "../Modal";
import { useHistory } from "react-router-dom";
import commonService from "../../services/commonService";
import cookie from "../../libs/cookie/client";
import { Link } from 'react-router-dom';
import Logo from '../../assets/logo.svg'

const EmailsentModel = (props) => {
   
    const history = useHistory();
    const userData = commonService.getUserData();
  
    const closePopup = () => { };

    const OnNavigate = () => {
        cookie.removeItem('email');
        localStorage.removeItem("email");
        history.push("/login/");
    }
    const Gotohome = () => {
        cookie.removeItem('email');
        localStorage.removeItem("email");
        history.push(`/`);
    }

    return (

        <Modal isOpen={props.isOpen} closeTrigger={() => closePopup()}>
            <div className="py-8 xl:py-8 px-4 w-auto" style={{ height: 400, overflow: "hidden" }}>

                <div className=" flex items-center flex-col justify-center">

                    <img src={Logo} alt="Viewpro" />
                        <div className="my-6  w-fit text-center font-semibold text-5xl text-primary">Reset Password</div>
                        <div className="mx-10 text-xl text-center">An email with password reset link has been sent to your email <span className="font-bold text-primary">&nbsp;&nbsp;{cookie.getItem("email")}</span> </div>
                        <div className="my-2 text-lg text-center">Check your Email and click on the link to proceed. </div>
                        <div className=" mt-6">
                            <button to="/" type="submit" className="bg-primary hover:bg-primary-dark border-primary text-white font-semibold  text-base py-1.5 px-8 rounded-full inline-block border-2  active:border-3 disabled:opacity-50 focus:outline-none w-fit mb-2">
                                <Link onClick={() => Gotohome()} >Go to Home</Link>
                            </button>
                        </div>
                        <div className=" text-center flex justify-center border-t border-primary-light pt-4 mt-5 w-full">
                            <Link onClick={() => OnNavigate()} className="text-primary font-semibold w-full">Return to log in</Link>

                        </div>
                   
                </div>

            </div>
        </Modal>
    );
};

export default EmailsentModel;
